<template>
    
    <div class="py-3 py-md-4 py-lg-5 content-container">
        <alert v-if="error" color="danger" class="rounded-0 mb-0">
            {{ error }}
            <ui-button class="ms-3" @click="requestData">
                Try Again
            </ui-button>
        </alert>

        <h1 v-if="title" class="mb-5 display-1">{{ title }}</h1>
        <div v-else-if="!html && !error" class="mb-5">
            <placeholder  size="lg" :width="10"/>
        </div>
        
        <div v-if="iframe">
            <iframe :src="iframe" class="w-100 d-block border vh-70" frameborder="no"></iframe>
            <p class="small mt-2"><a :href="iframe" target="_blank">Open in new tab</a></p>
        </div>
        <div v-else-if="html">
            <html-content :html="html" :remove="['style']" class="agreement-content"/>
        </div>
        <div v-else-if="!error">

            <div v-for="p in 2" :key="`agreement-placeholder-paragraph-${p}`" class="mb-3">
                <placeholder v-for="index in 24" :key="`agreement-placeholder-sentence-${p}-${index}`" :width="randomWidth()"/>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import HtmlContent from '@/components/Content/HtmlContent.vue';
    import CommonComponents from '@/components/Common.vue';

    import ApiConfig from '@/config/api.json';
    import Utilities from '@/classes/Utilities.js';

    import { UseApiStore } from '@/store/Api.js';

    export default {
        components: {
            HtmlContent,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
            };
        },

        data() {
            return {
                iframe: null,
                title: null,
                disposed: false,

                error: null,
                requestsTimer: null,
                emptyResults: null,
            };
        },

        created() {

            this.$watch(
                () => this.$route.params,
                this.requestAndRefresh,
                { immediate: true }
            );
        },

        beforeRouteLeave(to, from) {
            if (
                (to.meta) &&
                (to.meta.multiRoute) &&
                (from.meta) &&
                (from.meta.multiRoute) &&
                (to.meta.multiRoute == from.meta.multiRoute)
            ) {
                return;
            }
            
            this.disposed = true;
            clearTimeout(this.requestsTimer);
        },

        computed: {

            requestUrl() {
                let re = 'content/agreements/';
                if (this.$route.params.agreementType) {
                    re += this.$route.params.agreementType;
                }
                else {
                    re += 'terms';
                }
                
                return re;
            },

            html() {
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {

                    if (
                        (!this.disposed) &&
                        (response.setMetaData) &&
                        (response.setMetaData instanceof Function)
                    ) {
                        response.setMetaData();
                    }

                    this.setTitle(response.results.title);

                    if (response.results.customFile) {
                        this.customFile(response.results.customFile);
                        return null;
                    }
                    else {
                        return this.filterBody(response.results.agreement);
                    }
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },

        },

        methods: {

            randomWidth() {
                return Utilities.random(2, 12);
            },

            requestAndRefresh() {
                this.title = null;
                this.requestData();
            },

            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                this.setEmptyResults(null);
                
                clearTimeout(this.requestsTimer);

                await this.apiStore.get({
                    url: this.requestUrl,
                    staticList: true,
                });

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardLongCache * 1000);
            },

            setError(error) {
                this.error = error;
            },

            setEmptyResults(val) {
                this.emptyResults = val;
            },

            filterBody(agreement) {
                // filter out the <html> and <body> tags
                let pos = agreement.indexOf('<body');
                if (pos != -1) {
                    agreement = agreement.substring(pos);
                    // find the closing tag
                    pos = agreement.indexOf('>');
                    if (pos != -1) {
                        agreement = agreement.substring(pos + 1);
                    }
                }

                pos = agreement.indexOf('</body>');
                if (pos != -1) {
                    agreement = agreement.substring(0, pos);
                }
                return agreement;
            },

            customFile(agreement) {
                this.iframe = agreement.url;
            },

            setTitle(title) {
                this.title = title;
            },
        }
    }
</script>